import React from "react";
import { useTheme } from "../..";
import { IPlan } from "../../interfaces/api";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import EnrollTooltip from "../EnrollTooltip.Component";
import { useEnrollLink } from "../../hooks/useEnrollLink";
import { useZipRootLoaderData } from "../../hooks/useZipRootLoaderData";

const ButtonsSection = ({
  data,
  componentId,
  fullData,
}: {
  data: string;
  componentId: string;
  fullData: IPlan;
}) => {
  const { yearsForZip } = useZipRootLoaderData();
  const { sticky, setSticky } = useTheme();
  const enrollmentLink = useEnrollLink(
    fullData.pbp,
    fullData.hcode,
    `${fullData.Year}`
  );

  const planYear =
    yearsForZip &&
    yearsForZip.find((item) => item.Year === Number(fullData.Year));

  const handleCheckboxChange = () => {
    let data = structuredClone(sticky);

    if (sticky.includes(componentId)) {
      data = data.filter((plan: any) => plan !== componentId);
    } else {
      data.push(componentId);
    }

    setSticky(data);
  };

  const goEnroll = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    window.open(enrollmentLink, "_blank");
  };

  return (
    <div className="grid-x align-justify" style={{ padding: "12px 40px 16px" }}>
      <div
        className="cell small-12 medium-8 show-for-small-only"
        style={{ display: "flex" }}
      >
        <button
          type="button"
          className="button"
          disabled={!planYear?.canEnroll}
          style={{
            flex: 1,
            width: "100%",
            minHeight: "60px",
            marginRight: 8,
            backgroundColor: !planYear?.canEnroll ? "#CACACA" : "",
          }}
          onClick={goEnroll}
        >
          Enroll
        </button>
        {!planYear?.canEnroll && planYear?.shouldDisplay && (
          <Tooltip
            anchorSelect=".enroll-button"
            place="top"
            style={{
              width: "75%",
              maxWidth: "600px",
              backgroundColor: "#F5F9FD",
              color: "black",
              padding: 28,
            }}
          >
            <EnrollTooltip />
          </Tooltip>
        )}
        <Link
          to={{
            pathname: "/plan-details",
            search: `?hcode=${fullData.hcode}&pbpid=${fullData.pbp}`,
          }}
          className="button hollow"
          style={{
            flex: 1,
            minHeight: "60px",
            fontWeight: 500,
            marginLeft: 8,
            width: "100%",
          }}
        >
          View Details
        </Link>
      </div>
      <div className="cell small-12 medium-8 hide-for-small-only">
        <button
          type="button"
          className="button my-anchor-element enroll-button"
          disabled={!planYear?.canEnroll}
          style={{
            minWidth: "180px",
            minHeight: "60px",
            marginRight: "16px",
            backgroundColor: !planYear?.canEnroll ? "#CACACA" : "",
          }}
          onClick={goEnroll}
        >
          Enroll
        </button>
        {!planYear?.canEnroll && planYear?.shouldDisplay && (
          <Tooltip
            anchorSelect=".enroll-button"
            place="top"
            style={{
              width: "75%",
              maxWidth: "600px",
              backgroundColor: "#F5F9FD",
              color: "black",
              padding: 28,
            }}
          >
            <EnrollTooltip />
          </Tooltip>
        )}

        <Link
          to={{
            pathname: "/plan-details",
            search: `?hcode=${fullData.hcode}&pbpid=${fullData.pbp}`,
          }}
          className="button hollow"
          style={{ minWidth: "180px", minHeight: "60px", fontWeight: 500 }}
        >
          View Details
        </Link>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <label
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            fontSize: "18px",
          }}
        >
          <div style={{ paddingRight: "15px" }}>Compare</div>
          <input
            type="checkbox"
            checked={sticky.includes(componentId)}
            onChange={handleCheckboxChange}
            title={
              sticky.length === 3
                ? "Only 3 plans can be compared at the same time"
                : ""
            }
            style={{ width: 18, height: 18 }}
            disabled={sticky.length === 3 && !sticky.includes(componentId)}
          />
        </label>
      </div>
      {sticky.length === 3 && !sticky.includes(componentId) && (
        <div style={{ marginLeft: "auto", color: "red" }}>
          Only 3 plans can be compared at the same time
        </div>
      )}
    </div>
  );
};

export default ButtonsSection;
